<template>
  <div :class="['dida', { extra: !!extraSource }]">
    <div class="dida__text" v-html="label"></div>
    <p v-if="extraSource" class="dida__extra-source">{{ extraSource }}</p>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import getUomAndMetadatum from "@/mixins/getUomAndMetadatum";
export default {
  name: "SelectionLabel",
  mixins: [getUomAndMetadatum],
  props: {
    withUom: {
      type: Boolean,
      default: true,
    },
    withGeoArea: {
      type: Boolean,
      default: true,
    },
    fixedText: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    extraSource: {
      type: String,
    },
  },
  computed: {
    label() {
      let res = `${this.fixedText} ${
        this.fixedText || this.withGeoArea
          ? this.$t("dashboard").sourceDidaPrep
          : ""
      } ${this.currentSelection}`;
      if (this.withUom) {
        res = `${res} <span class='uom'> ${
          this.type === "map" ? "-" : "<br>"
        } ${this.uom} ${
          this.metadatum !== undefined &&
          this.metadatum.dateUpdated !== undefined
            ? this.metadatum.dateUpdated
            : " "
        }</span>`;
      }
      //${this.metadatum.dateUpdated || ""}
      if (this.withGeoArea) {
        res = `${this.geoArea} ${res} `;
      } else {
        res = `World ${res} `;
      }
      return res;
    },
    currentSelection() {
      let res = "";
      if (this.currentSourceConfig) {
        const hasSource = this.currentSourceConfig.sources;
        const hasDataTypes = this.currentSourceConfig.dataTypes;

        if (hasSource && this.source && this.sourceName) {
          res = this.sourceName;
        } else {
          res = this.mainSource;
        }

        if (hasDataTypes && this.dataType) {
          res += ` ${this.changeLabel(this.dataType)}`;
        }
      }

      return res;
    },
    sourceName() {
      return this.currentSourceConfig.sources.find((x) => x.key === this.source)
        ?.name;
    },

    ...mapGetters({
      uoms: "ui/uom",
      metadata: "ui/metadata",
      dataType: "ui/dataType",
      mainSource: "ui/mainSource",
      source: "ui/source",
      geoArea: "ui/geoArea",
      currentSourceConfig: "ui/currentSourceConfig",
    }),
  },
  methods: {
    changeLabel(oldLabel) {
      // patch to change wind labels
      const map = this.currentSourceConfig.dataTypesMap;
      if (!map) return oldLabel;

      return map.find((o) => o.key.toUpperCase() === oldLabel.toUpperCase())
        .label;
    },
  },
};
</script>
<style lang="scss" scoped>
.dida {
  display: flex;
  width: 100%;
  height: 100%;
  color: $ui-white;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  &.extra {
    flex-direction: column;
  }

  &__text {
    @include title-H6;
    width: 100%;
    display: inline;
    ::v-deep .uom {
      @include dida-S;
    }
  }

  &__extra-source {
    color: $gray_03;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 17px;
    padding: toRem(4) 0;
  }
}

.mobile,
.tablet {
  .dida {
    .text {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
